import { render, staticRenderFns } from "./user.vue?vue&type=template&id=c2c38e12&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.vue?vue&type=style&index=0&id=c2c38e12&prod&scoped=true&lang=css&"
import style1 from "./user.vue?vue&type=style&index=1&id=c2c38e12&prod&lang=css&"
import style2 from "./user.vue?vue&type=style&index=2&id=c2c38e12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c38e12",
  null
  
)

export default component.exports